export default __webpack_public_path__ + "static/media/logo-us-athleta.14087df0.svg";